import { CardIcon } from "@/features/patient-ar/components/StatementCardIcons";
import { Plus } from "lucide-react";
import { twMerge } from "tailwind-merge";

interface CardStatusIconProps {
  hasCard: boolean;
  size?: number;
}

export function CardStatusIcon({ hasCard, size = 40 }: CardStatusIconProps) {
  const wrapperProps = {
    className: "rounded-full flex items-center justify-center",
    style: { width: size, height: size },
    role: "img",
  };

  if (hasCard) {
    return (
      <div
        {...wrapperProps}
        aria-label="Card on File"
        className={twMerge(wrapperProps.className, "bg-[#EAF3FF]")}
      >
        <CardIcon className="size-[15px] text-[#1884F9]" />
      </div>
    );
  }

  return (
    <div
      {...wrapperProps}
      aria-label="No card on file"
      className={twMerge(
        wrapperProps.className,
        "border border-dashed border-[#F3C6CB] bg-[#FFEEEE]",
      )}
    >
      <Plus className="size-[15px] text-[#CE2C31]" />
    </div>
  );
}
